<template lang="pug">
vm-row(vm-w="12")
  vm-col.card(vm-sm=12)
    vm-table(multiple v-model="selected"  max-height="350px" :data="requisitionsMailboxes" )
      template(slot="header")
        .d-flex.justify-content-between
          vm-input(ref="search" icon="search" size="small" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="200px")
          div
            vm-button(class="btn-requisitions" @click="deleteRecords" :disabled="!enabledDelete")
              vm-icon(icon="trash-2-outline")
            vm-tooltip(:text="$t('strings.filters')" delay=".5s")
              vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="default" icon="funnel-outline" size="small")
                vm-dropdown-menu(class="filters")
                  .heading.d-flex.justify-content-between
                    h4 {{ $t('strings.filters') }}
                    vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                  vm-date-picker.filter(type="daterange" :label="$t('requisitions_mailboxes.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                  .filter.d-flex
                    vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
            vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('requisitions_mailboxes.'+ item)")
              vm-order-by-item(value='id,asc' text='#' direction='down')
              vm-order-by-item(value='id,desc' text='#' direction='up')
              vm-order-by-item(value='folio,asc' text='folio' direction='down')
              vm-order-by-item(value='folio,desc' text='folio' direction='up')
            vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
              vm-button(type="default" size="small" icon="list" style="display: none;")
            vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
              vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
      template(slot="thead")
        vm-th(:key="index" v-for="(column, index) in columns") {{ $t('requisitions_mailboxes.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
            .details(@click="editRequisition(data[indextr])")
              slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'id'")  {{data[indextr][column]}}
              slot(v-if="column == 'project'")  {{data[indextr][column]['name']}}
              slot(v-if="column == 'user'")  {{data[indextr][column]['name']}}
              slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column != 'status' && column != 'id' && column != 'project'  && column != 'user' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
              vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
          vm-td
          vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
            vm-dropdown-menu
              vm-dropdown-item.d-flex.justify-content-between(@click="showOrders(data[indextr], tr)")
                vm-icon(icon="file-text-outline")
                slot &nbsp;{{ $t('strings.purchase_orders') }}
              vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == 'Inactivo'" @click="setActionRecord(data[indextr], 'actived')")
                vm-icon(icon="person-done-outline")
                slot &nbsp;{{ $t('strings.action_active') }}
              vm-dropdown-item.d-flex.justify-content-between(  @click="deleteRequisitionConfirm(data[indextr])")
                vm-icon(icon="trash-2-outline")
                slot &nbsp;{{ $t('strings.delete') }}
              //- More actions
    vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
    transition(name="enter")
      .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('RequisitionsMailboxes')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalRequisitionsMailboxes = () => import('@/components/modals/ModalRequisitionsMailboxes.vue')

export default {
  name: 'MailboxesView',
  components: {
    ModalImport,
    ModalRequisitionsMailboxes
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'folio', 'project', 'product_amount', 'user', 'created_at'],
    columnsOrderBy: ['id', 'folio'],
    attributeModal: 'id',
    status: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        id: '',
        folio: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['requisitionsMailboxes', 'catalog', 'pagination', 'filterParams'])
  },
  watch: {
    currentPage (page) {
      this.loadRecords({ page })
    }
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRequisition',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter'
    ]),
    async getRecords () {
      this.filters.where.status = 'pending'
      this.applyFilter(this.filters)
      await this.loadRecords({ page: this.currentPage })
    },
    editRequisition (payload, row) {
      this.$router.push(`create-purcharse-orders/${payload.id}`)
    },
    showOrders (record) {
      this.$router.push({ path: `/purcharse-orders/${record.id}/summary` })
    },
    deleteRequisitionConfirm (record) {
      let t = this
      this.auxDeleteRecord = () => {
        t.deleteRequisition(record).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.requisition'),
          attribute: record.folio
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    .vm-button {
      background-color: white !important;
      color: #929292;
      padding: 0 !important;
      width: 30px;
      height: 30px;
    }
    .con-vm-tooltip {
      margin: -9px 0;
    }
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
